import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'
import hotel from './modules/hotel'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    ...modules,   // 展開原本的 modules
    hotel      // 加上新的 hotel 模組
  },
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

export default store

// Automatically run the `init` action for every module,
// if one exists.
// dispatchActionForAllModules('init')
